import React, {Component, PropTypes} from 'react';
import DatePicker from 'react-datepicker';
import { lang } from '../../strings';
import { getDate, formatDate } from '../../utils/date';
import { trackEvent, DATAPACKAGE, LOAD} from '../../utils/analytics';

export default class DataPackageDialog extends Component {

   constructor(props) {
      super(props);
      this.state = this.makeInitialState(props);
   }

   makeInitialState(props) {
      return {
         selectedDate: getDate(),
         showDatePicker: false,
         selectedDataPackageId: null,
         activationType: null
      };
   }

   componentDidMount() {
      trackEvent(DATAPACKAGE, LOAD);
   }

   render() {
      let { dataPackages, currentDataPackage } = this.props;
      let { selectedDate, activationType } = this.state;
      let showDatePicker = activationType == DataPackageDialog.activationTypes.date;

      return ( <div className="mp-popup-container">
            <div className="mp-popup-content">
               <a href="#" className="mp-close" onClick={this.closeForm}>&times;</a>
               <h2 className="h5 color-dark-blue">{lang.dataPackage.dialog.title}</h2>
               <p>{currentDataPackage ? <span>{lang.dataPackage.dialog.current}: {currentDataPackage}</span> : ''}</p>
               
               <form onSubmit={this.submitForm}>
                  <div className="mp-block">
                     <div className="mp-block-half">
                        <h2 className="h5 color-dark-blue">Nytt datapaket</h2>
                        <ul className="mp-list">
                            {dataPackages.map(dataPackage =>
                                <li key={dataPackage.id}>
                                    <label>
                                        <input type="radio" name="dataPackage" value={dataPackage.id} onChange={this.handleSelectedChange} /> {dataPackage.name}
                                    </label>
                                </li>
                            )}
                        </ul>
                     </div>
                     <div className="mp-block-half">
                        <h2 className="h5 color-dark-blue">{lang.dataPackage.dialog.activate}</h2>
                        <p>
                           <ul className="mp-list">
                              <li>
                                 <label>
                                    <input type="radio" name="activationType" onChange={this.onActivationTypeChange} value={DataPackageDialog.activationTypes.direct} /> {lang.dataPackage.dialog.direct}
                                 </label>
                              </li>
                              <li>
                                 <label>
                                    <input type="radio" name="activationType" onChange={this.onActivationTypeChange} value={DataPackageDialog.activationTypes.date} />  {lang.dataPackage.dialog.date}
                                 </label>
                              </li>
                           </ul>
                        </p>
                        {showDatePicker ? <DatePicker minDate={getDate()} locale="sv" selected={selectedDate} onChange={this.onDateChange} /> : null}
                     </div>
                  </div>
                  <p><input type="submit" className={this.setSubmitClass()} value={lang.dataPackage.dialog.title} /></p>
               </form>
            </div>
         </div>
      );
   }

   setSubmitClass() {
      let { activationType, selectedDataPackageId } = this.state;
      return activationType && selectedDataPackageId ? 'mp-submit' : 'mp-disabled mp-submit';
   }

   onActivationTypeChange = ev => {
      this.setState({activationType: ev.target.value});
   };

   onDateChange = date =>  {
      this.setState({selectedDate: date});
   };

   handleSelectedChange = ev => {
      this.setState({selectedDataPackageId: ev.target.value});
   };

   closeForm = ev => {
      ev.preventDefault();
      this.props.onClose();
   };

   submitForm = ev => {
      ev.preventDefault();
      let { selectedDataPackageId, selectedDate } = this.state;
      let activationTime = null;
      if(this.state.activationType == DataPackageDialog.activationTypes.direct) {
         activationTime = getDate();
      }
      else if(this.state.activationType == DataPackageDialog.activationTypes.date) {
         activationTime = formatDate(selectedDate, 'L');
      }

      let data = {
         selectedDataPackageId: selectedDataPackageId,
         activationDate: activationTime
      };

      this.props.onSubmit(data);
   };
}

DataPackageDialog.activationTypes = {
   direct: 1,
   date: 2
};

DataPackageDialog.propTypes = {
   onClose: PropTypes.func.isRequired,
   onSubmit: PropTypes.func.isRequired,
   dataPackages: PropTypes.object.isRequired,
   currentDataPackage: PropTypes.string.isRequired
};